import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";

function handleRemoveResourceFromPlanzoneSucceeded(
  group: Identifiable<Group>,
  { resource }: Boundaries["removeResourceFromPlanzone"]["success"],
): Identifiable<Group> {
  return {
    ...group,
    resources: group.resources.filter((r) => r.uuid !== resource.uuid),
  };
}

export { handleRemoveResourceFromPlanzoneSucceeded };
